module.exports = __webpack_public_path__ + "static/media/close-light.7d77775a.png";